import { Nullable } from "@brg/api";
import { useAuth, useProfile } from "@brg/auth";
import { useModal } from "core";
import { FC } from "react";
import { ITeamEntity } from "shared/hooks/useGetCurrentTeam";
import { ExploreButtonFilled, ExploreButtonHollow } from "shared/pages/explore/styles";
import { SpecialButtonsType } from "shared/pages/teams/components/SpecialDropdownButtons";

export const SpecialTypeButtons: FC<{ 
    type: string, 
    text: string, 
    hide?: boolean, 
    specialType: SpecialButtonsType, 
    team?: Nullable<ITeamEntity>,
    action?: () => void, 
}> = ({ 
    team, 
    type, 
    text, 
    specialType, 
    hide,
    action, 
}) => {
    const profile = useProfile();
    const auth = useAuth();
    const modal = useModal();
    if (hide) {
        return null;
    }

    const getActionFn = () => {
        
        if (specialType === SpecialButtonsType.connect) {
            if (profile) {
                modal.show('send-project-employ',
                  {
                    team,
                  })
                return;
              }
              auth.login()
        }
    }

    const onClick = () => {
        if (action) {
            action();
            return;
        }

        getActionFn()
    }

    if (!team) {
        return null;
    }
    
    return (
        <>
        {type === 'filled' ? (
            <ExploreButtonFilled className={`special-button filled-button context-button`} fixedSize onClick={onClick}>
                {text}
            </ExploreButtonFilled>
        ) : (
            <ExploreButtonHollow className={'special-button hollow-button context-button'} fixedSize onClick={onClick}>
                {text}
            </ExploreButtonHollow>
        )}
        </>
    )
}import { Nullable } from "@brg/api";
import { useAuth, useProfile } from "@brg/auth";
import { useModal } from "core";
import { FC } from "react";
import { ITeamEntity } from "shared/hooks/useGetCurrentTeam";
import { ExploreButtonFilled, ExploreButtonHollow } from "shared/pages/explore/styles";
import { SpecialButtonsType } from "shared/pages/teams/components/SpecialDropdownButtons";

export const SpecialTypeButtons: FC<{ 
    type: string, 
    text: string, 
    hide?: boolean, 
    specialType: SpecialButtonsType, 
    team?: Nullable<ITeamEntity>,
    action?: () => void, 
}> = ({ 
    team, 
    type, 
    text, 
    specialType, 
    hide,
    action, 
}) => {
    const profile = useProfile();
    const auth = useAuth();
    const modal = useModal();
    if (hide) {
        return null;
    }

    const getActionFn = () => {
        
        if (specialType === SpecialButtonsType.connect) {
            if (profile) {
                modal.show('send-project-employ',
                  {
                    team,
                  })
                return;
              }
              auth.login()
        }
    }

    const onClick = () => {
        if (action) {
            action();
            return;
        }

        getActionFn()
    }

    if (!team) {
        return null;
    }
    
    return (
        <>
        {type === 'filled' ? (
            <ExploreButtonFilled className={`special-button filled-button context-button`} fixedSize onClick={onClick}>
                {text}
            </ExploreButtonFilled>
        ) : (
            <ExploreButtonHollow className={'special-button hollow-button context-button'} fixedSize onClick={onClick}>
                {text}
            </ExploreButtonHollow>
        )}
        </>
    )
}